import gsap from 'gsap'
import DOMAnimations from '../utils/dom-animations'

export default class PrimaryNavigation {
    private navWrapper: null | HTMLUListElement
    private breakpoint = 768
    private tl: gsap.core.Timeline
    private $menu: HTMLDivElement | null = null
    private $burger: Element | null = null
    private hasLightTheme = false

    constructor() {
        this.navWrapper = null
        this.tl = gsap.timeline({ paused: true })
    }

    start() {
        console.log('[Application] PrimaryNavigation loaded')
        this.initMenu()
    }

    initMenu() {
        this.hasLightTheme = document.body.classList.contains('page-template-page-texte')
        this.navWrapper = document.querySelector('.nav-primary-wrapper')
        this.$menu = document.querySelector('.primary-navigation-wrapper')
        this.$burger = document.querySelector('.nav-head .burger')
        const self = this
        const $links: NodeListOf<Element> = document.querySelectorAll('.nav-body ul > .lv1')
        const $linksLv1: NodeListOf<Element> = document.querySelectorAll('.nav-body .primary-menu .lv1')
        const $linksLv3: NodeListOf<Element> = document.querySelectorAll('.nav-body .primary-menu .lv2')
        const $topMenuLv1: NodeListOf<Element> = document.querySelectorAll(
            '.nav-body .top-menu .lv1.menu-item-has-children'
        )
        const $buttonClose: Element = document.querySelector('.nav-head .close')
        const $menuIcons: NodeListOf<Element> = document.querySelectorAll('.nav-head .menu-icon')
        const $backMainMenu: NodeListOf<Element> = document.querySelectorAll('.nav-body .back')
        // -60 so it won't be jumpy
        const offsetAdd: number = 120
        const stop = (self.$menu?.offsetTop || 0) + offsetAdd
        const docBody = document.documentElement || document.body.parentNode || document.body
        const hasOffset: boolean = window.pageYOffset !== undefined
        const mobileBgColor = this.hasLightTheme ? '#ffffff' : '#000119'
        let scrollTop

        window.onscroll = function (e) {
            e.stopPropagation()
            // cross-browser compatible scrollTop.
            scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop
            if (scrollTop >= stop) {
                // stick the div
                self.$menu?.classList.add('fixed')
                self.$menu?.removeAttribute('style')
            } else {
                // release the div
                self.$menu?.classList.remove('fixed')
            }
        }

        this.$links = $links
        this.tl.fromTo(
            self.$menu,
            {
                height: '60px'
            },
            {
                duration: 0.5,
                opacity: 1,
                height: '100vh',
                backgroundColor: mobileBgColor,
                position: 'fixed',
                ease: 'expo.inOut'
            }
        )
        this.tl.to(
            $menuIcons,
            {
                duration: 0.3,
                opacity: 0,
                ease: 'expo.inOut'
            },
            '-=0.3'
        )
        this.tl.to($buttonClose, {
            duration: 0.3,
            opacity: 1,
            ease: 'expo.inOut'
        })
        this.tl.fromTo(
            $links,
            {
                opacity: 0,
                backgroundColor: mobileBgColor,
                y: 20
            },
            {
                duration: 0.3,
                opacity: 1,
                y: 0,
                stagger: 0.1,
                backgroundColor: mobileBgColor,
                ease: 'expo.inOut'
            },
            '-=0.3'
        )
        this.tl.reverse()

        this.$burger?.addEventListener('click', function (e) {
            e.preventDefault()
            e.stopPropagation()
            self.showHideMenu()
        })
        $buttonClose?.addEventListener('click', function (e) {
            e.preventDefault()
            e.stopPropagation()
            self.showHideMenu()
        })

        $linksLv1.forEach($link => {
            if ($link.classList.contains('menu-item-has-children')) {
                $link.querySelector('a').addEventListener('click', function (e) {
                    e.preventDefault()
                    e.stopPropagation()
                    if (self.$menu?.classList.contains('open')) {
                        this.nextElementSibling.classList.add('visible')
                        $links.forEach($link => {
                            $link.classList.add('slide')
                        })
                        document.querySelector('.nav-body').style.height = '92vh'
                    }
                })
            }
        })

        $linksLv3.forEach($link => {
            if ($link.classList.contains('menu-item-has-children')) {
                $link.querySelector('a').addEventListener('click', function (e) {
                    e.preventDefault()
                    e.stopPropagation()
                    if (self.$menu?.classList.contains('open')) {
                        DOMAnimations.slideToggle(this.parentElement.querySelector('.sub-menu'))
                        this.classList.toggle('active')
                    }
                })
            }
        })

        $topMenuLv1.forEach($link => {
            if ($link.classList.contains('menu-item-has-children')) {
                $link.querySelector('a').addEventListener('click', function (e) {
                    e.preventDefault()
                    e.stopPropagation()
                    if (self.$menu?.classList.contains('open')) {
                        DOMAnimations.slideToggle(this.parentElement.querySelector('.sub-menu'))
                        this.classList.toggle('active')
                    }
                })
            }
        })

        $backMainMenu.forEach($back => {
            $back.addEventListener('click', e => {
                e.preventDefault()
                e.stopPropagation()
                if (self.$menu?.classList.contains('open')) {
                    this.backMenu()
                    if (self.$menu) self.$menu.dataset.illustration = ''
                }
            })
        })

        this.handleEntryClick()
    }

    backMenu() {
        document.querySelector('.sub-menu.visible').classList.remove('visible')
        this.$links.forEach($link => {
            $link.classList.remove('slide')
        })
        document.querySelector('.nav-body').style.height = 'auto'
    }

    showHideMenu(callBack = () => {}) {
        this.$burger?.classList.toggle('close')
        this.$menu?.classList.toggle('open')
        this.tl.reversed(!this.tl.reversed()).then(() => callBack && callBack())
        document.getElementById('app')?.classList.toggle('menu-open')
    }

    onAnchorLinkClicked(href: string) {
        this.showHideMenu(() => {
            window.location.href = href
            console.log('onAnchorLinkClicked: ', href)
        })
    }

    handleEntryClick() {
        if (!this.navWrapper) {
            return
        }

        const links = this.navWrapper.querySelectorAll('li > a')
        const elementsWithAnchorId = document.querySelectorAll('*[id]')
        const menuEntriesWithAnchors = Array.from(links).filter(link => {
            const a = link as HTMLAnchorElement
            const href = a.href

            try {
                const anchor = href.split('#')[1]

                return !!Array.from(elementsWithAnchorId).find(el => el.getAttribute('id') === anchor)
            } catch (e: unknown) {
                console.log(e)
            }

            return false
        })

        menuEntriesWithAnchors.forEach(link => {
            const a = link as HTMLAnchorElement

            a.addEventListener('click', (event: MouseEvent) => {
                if (window.screen.width <= this.breakpoint) {
                    event.preventDefault()
                    this.onAnchorLinkClicked((event.target as HTMLAnchorElement).href)
                }
            })
        })
        console.log('menuEntriesWithAnchors: ', menuEntriesWithAnchors)
    }
}
